export default {
  banner_v2: {
    title: '<span class={title}>Get <span class={highlight}>$100</span> and more during DSers Reward Season</span>',
    desc: `DSers Reward Season will be held from 15th Oct ~ 15th Jan. <br />
      Invitations will be sent to random merchants in September. <br />
      Please check the mailbox of the email you used to create your DSers account.`,
    learn_more: 'Learn more'
  }
};
